import { createSlice } from "@reduxjs/toolkit";

const LiveTable = createSlice({
  name: "LiveTable",
  initialState: {
    liveTablePopup: false,
    liveTableDetails: {
      bookings: [],
    },
    loading : false,
  
  },
  reducers: {
    setSelectedLiveTable: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetSelectedLiveTable: (state) => {
      return state = {
          liveTablePopup: false,
          liveTableDetails: {
            bookings: [],
          },
          loading: false,
      };
    },
    updateLiveBookingDetailsBookingStatus: (state, action) => {
      const { bookingId, newStatus } = action.payload;
      if (state.liveTableDetails && state.liveTableDetails.bookings) {
        if (newStatus) {
          state.liveTableDetails.status = newStatus;
          state.liveTableDetails.is_free = newStatus === "free";
          state.liveTableDetails.is_occupied = newStatus === "occupied";
          state.liveTableDetails.is_reserved = newStatus === "reserved";
          state.liveTableDetails.is_checked_in = newStatus === "checked_in";
        }
        state.liveTableDetails.bookings = state.liveTableDetails.bookings.map((booking) =>
          Number(booking.id) === Number(bookingId) ? { ...booking, table_status: newStatus, status: newStatus || booking.status } : booking
        );
      }
    },
    updateBookingInLiveDetails: (state, action) => {
      const payload = action.payload;
      if (state.liveTableDetails && state.liveTableDetails.bookings) {
        state.liveTableDetails.bookings = state.liveTableDetails.bookings.map((booking) => {
          if (Number(booking.id) !== Number(payload.booking_id)) return booking;
          return {
            ...booking,
            unique_id: payload.unique_id || booking.unique_id,
            reservation_date: payload.reservation_date || booking.reservation_date,
            start_time: payload.start_time || booking.start_time,
            end_time: payload.end_time || booking.end_time,
            guest: payload.guest !== undefined ? Number(payload.guest) : booking.guest,
            advance: payload.advance !== undefined ? Number(payload.advance) : booking.advance,
            status: payload.status || booking.status,
            table_status: payload.table_status || booking.table_status,
            customer: booking.customer ? {
              ...booking.customer,
              full_name: payload.customer_name || booking.customer.full_name,
            } : {
              full_name: payload.customer_name,
            }
          };
        });
      }
    },
    addNewBookingToLiveDetails: (state, action) => {
      const newBooking = action.payload;
      if (!newBooking || !state.liveTableDetails) return state;
      const currentTableId = state.liveTableDetails?.id;
      if (!currentTableId || Number(currentTableId) === Number(newBooking.table_id)) {
        const existing = state.liveTableDetails.bookings || [];
        const exists = existing.some((b) => Number(b.id) === Number(newBooking.id));
        return {
          ...state,
          liveTableDetails: {
            ...state.liveTableDetails,
            is_free: false,
            is_occupied: true,
            status: "occupied",
            bookings: exists
              ? existing.map((b) => Number(b.id) === Number(newBooking.id) ? { ...b, ...newBooking } : b)
              : [...existing, newBooking],
          },
        };
      }
      return state;
    },
    removeBookingFromLiveDetails: (state, action) => {
      const { bookingId } = action.payload;
      if (state.liveTableDetails && state.liveTableDetails.bookings) {
        state.liveTableDetails.bookings = state.liveTableDetails.bookings.filter(
          (booking) => Number(booking.id) !== Number(bookingId)
        );
      }
    },
  },
});

export const { setSelectedLiveTable, resetSelectedLiveTable, updateLiveBookingDetailsBookingStatus, updateBookingInLiveDetails, addNewBookingToLiveDetails, removeBookingFromLiveDetails } = LiveTable.actions;

export default LiveTable.reducer;